export default "__VITE_ASSET__CpjBI6DE__"